export default class ItemImagesElement extends HTMLElement {
  constructor() {
    super();
  }

}
customElements.define('item-images', ItemImagesElement);